import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    StudentPaymentTemp,
    StudentPaymentTempSearch,
    IPageableStudentPaymentTemp,
    PendingRequestDTO,
    PendingTransactionPublicDTO,
} from '../student-payment/student-payment.model';
import { PrincipalService } from '@ms/core/auth/principal.service';
import { httpParams, logRequest } from '../shared/http-utils';
import { IPage } from '../shared/page/page.model';

@Injectable({
    providedIn: 'root',
})
export class StudentPaymentService {
    baseUrl = '/school-service/api/student-payments';

    constructor(
        private http: HttpClient,
        private principalService: PrincipalService
    ) {
        console.log('Student Payment service created');
    }

    getById(paymentId: string): Observable<HttpResponse<StudentPaymentTemp>> {
        return this.http.get<StudentPaymentTemp>(`${this.baseUrl}/${paymentId}`, {
            observe: 'response',
        });
    }

    deleteById(paymentId: string): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${paymentId}`, { observe: 'response', headers: logRequest() });
    }

    create(payment: StudentPaymentTemp): Observable<HttpResponse<StudentPaymentTemp>> {
        payment.schoolId = this.principalService.authenticatedUser.activeSchool.id;
        return this.http.post<StudentPaymentTemp>(this.baseUrl, payment, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    update(payment: StudentPaymentTemp): Observable<HttpResponse<StudentPaymentTemp>> {
        if (!payment.schoolId) {
            payment.schoolId = this.principalService.authenticatedUser.activeSchool.id;
        }
        return this.http.put<StudentPaymentTemp>(this.baseUrl, payment, { observe: 'response', headers: logRequest() });
    }

    searchStudentPaymentTempWithPagination(
        studentPaymentTempSearchDTO: StudentPaymentTempSearch,
        params?: any
    ): Observable<HttpResponse<IPage<IPageableStudentPaymentTemp>>> {
        studentPaymentTempSearchDTO.schoolId = this.principalService.authenticatedUser.activeSchool.id;
        return this.http.post<IPage<IPageableStudentPaymentTemp>>(
            `${this.baseUrl}/search/pageable`,
            studentPaymentTempSearchDTO,
            {
                observe: 'response',
                params: httpParams(params),
            }
        );
    }

    apply(payment: StudentPaymentTemp): Observable<HttpResponse<StudentPaymentTemp>> {
        if (!payment.schoolId) {
            payment.schoolId = this.principalService.authenticatedUser.activeSchool.id;
        }
        return this.http.post<StudentPaymentTemp>(`${this.baseUrl}/apply`, payment, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    unApply(studentPaymentId: string): Observable<HttpResponse<any>> {
        return this.http.get<StudentPaymentTemp>(`${this.baseUrl}/unapply/${studentPaymentId}`, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    map(response: StudentPaymentTemp): StudentPaymentTemp {
        const result: StudentPaymentTemp = Object.assign({}, response);
        result.details = Object.assign([], result.details);
        result.details.forEach(detail => {
            detail.student = Object.assign({}, detail.student);
        });
        console.log('Map Result:', result);
        return result;
    }

    getPendingPayments(dto: PendingRequestDTO): Observable<HttpResponse<PendingTransactionPublicDTO[]>> {
        return this.http.post<PendingTransactionPublicDTO[]>(`${this.baseUrl}/pending-payments`, dto, {
            observe: 'response',
        });
    }
}
